export { IconsHouse2 } from "./IconsHouse2";
